import { SVGProps } from 'react';

export const SvgCheckCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M0 8C0 3.59892 3.59892 0 8 0C12.4011 0 16 3.59892 16 8C16 12.4011 12.4011 16 8 16C3.59892 16 0 12.4011 0 8ZM8 0.941177C4.11872 0.941177 0.941177 4.11872 0.941177 8C0.941177 11.8813 4.11872 15.0588 8 15.0588C11.8813 15.0588 15.0588 11.8813 15.0588 8C15.0588 4.11872 11.8813 0.941177 8 0.941177Z" />
    <path d="M11.8501 5.47484C12.0502 5.66339 12.0499 5.96883 11.8495 6.15705L7.19717 10.5256C6.99685 10.7137 6.6724 10.7136 6.47225 10.5253L4.1502 8.34102C3.94993 8.15264 3.94993 7.8472 4.1502 7.65882C4.35047 7.47043 4.67517 7.47043 4.87544 7.65882L6.83519 9.50229L11.1249 5.47424C11.3253 5.28602 11.65 5.28629 11.8501 5.47484Z" />
  </svg>
);
